import * as React from 'react';
import { PropsWithChildren } from 'react';
import { Button, IconElement } from '@wix/design-system';
import classNames from 'classnames';
import s from './ActionButton.scss';

interface ActionButtonProps {
  dataHook?: string;
  className?: string;
  suffixIcon?: IconElement;
  type?: 'submit';
  onClick?: () => void;
}

export const ActionButton = ({
  dataHook,
  className,
  suffixIcon,
  type,
  children,
  onClick,
}: PropsWithChildren<ActionButtonProps>) => {
  return (
    <Button
      skin='dark'
      priority='secondary'
      dataHook={dataHook}
      suffixIcon={suffixIcon}
      type={type}
      className={classNames(s.actionButton, className)}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};
